/* eslint-disable */
import * as firebase from 'firebase'
import 'firebase/auth'
import 'firebase/messaging';
import 'firebase/analytics'

const config = {
  apiKey: "AIzaSyDgWMdzPrTl_QTzJ44hraa6pda0uGK3Jis",
  authDomain: "tender-test-bc015.firebaseapp.com",
  databaseURL: "https://tender-test-bc015.firebaseio.com",
  projectId: "tender-test-bc015",
  storageBucket: "tender-test-bc015.appspot.com",
  messagingSenderId: "245246244239",
  appId: "1:245246244239:web:ac4abf267a03512dfac7fa",
  measurementId: "G-TRNNT2ZBER"
};

const configProd = {
  apiKey: "AIzaSyBAaoVhihNoFK3reJujpNty0d3puapXCaQ",
  authDomain: "tender-8006e.firebaseapp.com",
  databaseURL: "https://tender-8006e.firebaseio.com",
  projectId: "tender-8006e",
  storageBucket: "tender-8006e.appspot.com",
  messagingSenderId: "380826260553",
  appId: "1:380826260553:web:bbad96a1dc09626dfb9b98",
  measurementId: "G-8MZYPFTZ0F"
}

if (!firebase.apps.length) {
  firebase.initializeApp(configProd)
}

firebase.analytics.isSupported().then((isSupported) => {
  // console.log(isSupported)
  if (isSupported) {
    firebase.analytics();
  }
})
const fireDb = firebase.database()
const fireStorage = firebase.storage()
const auth = firebase.auth()
let messaging = null
if (firebase.messaging.isSupported()){
  messaging = firebase.messaging()
  messaging.usePublicVapidKey("BLANFXql_MaEqdpaXeV2Q4cAcFI6CJ09T5ih800VyuC0pPLxrRao-P-5gqAebF1uWl9di-_-tuI9yYH6B2tYXIU")

}
export { fireDb, fireStorage, auth, messaging }
/* eslint-enable */
